/**
 * Parallax Module
 * パララックス効果
 */
export class Parallax {
  constructor() {
    this.elements = document.querySelectorAll('.js-parallax');
    this.scrollHandler = null;
    this.scrollTimer = null;
    this.elementData = new Map();
    
    if (this.elements.length > 0) {
      this.init();
    }
  }
  
  init() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // 各要素の初期位置とparallax値を保存
    this.elements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const parallaxValue = parseFloat(element.getAttribute('data-parallax')) || 0.5;
      
      this.elementData.set(element, {
        top: rect.top + scrollTop,
        parallaxValue
      });
    });
    
    this.updateParallax();
    this.setupScrollHandler();
  }
  
  /**
   * スクロールハンドラーを設定（スロットル付き）
   */
  setupScrollHandler() {
    this.scrollHandler = () => {
      if (this.scrollTimer) {
        return;
      }
      
      this.scrollTimer = requestAnimationFrame(() => {
        this.updateParallax();
        this.scrollTimer = null;
      });
    };
    
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
  }
  
  /**
   * パララックス効果を更新
   */
  updateParallax() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    
    this.elements.forEach((element) => {
      const data = this.elementData.get(element);
      if (!data) return;
      
      const { top: elementTop, parallaxValue } = data;
      const enterScrollTop = elementTop - windowHeight;
      const scrolledFromEnter = Math.max(0, scrollTop - enterScrollTop);
      const moveY = scrolledFromEnter * parallaxValue;
      
      element.style.transform = `translateY(${moveY}px)`;
    });
  }
  
  /**
   * イベントリスナーを削除
   */
  destroy() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }
    
    if (this.scrollTimer) {
      cancelAnimationFrame(this.scrollTimer);
      this.scrollTimer = null;
    }
  }
}
